import { Message } from 'element-ui';
import Cookies from 'js-cookie'
import store from '@/store/index.js'
function add0(m){return m<10?'0'+m:m }
    //时间format转换
function  formatTimer(timer,type){
        // if(!time) return "暂无数据"
        if(!timer) return "--"
        let time = new Date(timer);
        let y = time.getFullYear();
        let m = time.getMonth()+1;
        let d = time.getDate();
        if(type == 'day'){
            return y+'-'+add0(m)+'-'+add0(d);
        }else{
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
        }
    };
    
    function  reverseName(str){
        let fileName = "";
        if(!str) return;
        let reverseStr = str.split("").reverse().join("");
        let strSplit = reverseStr.split("/")[0];
        fileName = strSplit.split("").reverse().join("");
        return fileName;
      }
    function   splitFile(fileStr){
        let that = this;
        let fileList = [];
        if(!fileStr) return fileList;
        fileList = fileStr.split(",");
        fileList = fileList.map((item)=>{
          return {
            name: reverseName(item) || "",
            url:item || ""
          }
        })
        return fileList;
      }
     // 绩效考核  评价类型   pjRoleType
  const pjRoleTypeOpt = [
    {label:'上级评价打分',value:'1'},
    {label:'自我评价打分',value:'2'},
    {label:'协作评价打分',value:'3'},
    {label:'客户评价打分',value:'4'},
    {label:'领导评价打分',value:'5'},
  ];
  // 操作员类型
  const operTypeOpt = [
    {label:'部长',value:'3'},
    {label:'组长',value:'4'},
    {label:'员工',value:'5'},
  ];
  // 操作员全部类型
  const operTypeAllOpt = [
    {label:'平台管理员',value:'1'},
    {label:'总经理',value:'2'},
    {label:'部长',value:'3'},
    {label:'组长',value:'4'},
    {label:'员工',value:'5'},
    {label:'协商律师',value:'8'},
  ];
  // 员工等级
  const adminLevelOpt = [
    {label:'1',value:'1'},
    {label:'2',value:'2'},
    {label:'3',value:'3'},
    {label:'4',value:'4'},
    {label:'5',value:'5'},
  ];
  //员工在职状态
  const workStatusOpt =[
    {value:'入职',label:'入职'},
    {value:'转正',label:'转正'},
    {value:'试用',label:'试用'},
    {value:'离职',label:'离职'}
    ]
    //员工在职筛选状态
    const statusUserOpt =[
      {value:'1',label:'在职'},
      {value:'0',label:'已离职'}
      ]
  //绩效考核状态  status 
  const statusKpiOpt = [
    {label:'填写中',value:'1'},
    {label:'上级已评分',value:'2'},
    {label:'总监已评分',value:'3'},
    {label:'员工已确认',value:'4'},
  ];
  
    // 退费管理 =》是否已分配后端
    const isDistrOpt = [
        {label:'是',value:'1'},
        {label:'否',value:'0'},
    ];

   // status   公司列表:状态：1-正常 2-已删除
  const statusOpt = [
    {label:'正常',value:'1'},
    {label:'已删除',value:'2'},
  ];
   // status   帐号启用状态:0->禁用；1->启用; 2->删除
   const statusAccountOpt = [
    {label:'禁用',value:'0'},
    {label:'启用',value:'1'},
    {label:'删除',value:'2'},
  ];
  //    帐号启用状态:0->禁用；1->启用; 2->删除
  const genderOpt = [
    {label:'未知',value:'0'},
    {label:'男',value:'1'},
    {label:'女',value:'2'},
  ];
  //    关联定金   支付方式 1-固定金额，2-按解冻金额的百分比
  const remainTypeOpt = [
    {label:'固定金额',value:'1'},
    {label:'按解冻金额的百分比',value:'2'},
  ];
  
  // 信息类型 1-新闻动态 2-成功案例
  const typeDynamicOpt = [
    {label:'新闻动态',value:'1'},
    {label:'成功案例',value:'2'},
  ];
  
  // 是否有效 true:有效  false:无效
  const isValidOpt = [
    {label:'有效',value:true},
    {label:'无效',value:false},
  ];
  
 

  // 问题类型 1-前端 2-后端
  const typeAnswerOpt = [
    {label:'前端',value:'1'},
    {label:'后端',value:'2'},
  ];
  
  // 请假类型
  const typeApplyOpt = [
    {label:'事假',value:'1'},
    {label:'病假',value:'2'},
    {label:'出差',value:'3'},
    {label:'年休假',value:'4'},
    {label:'调休',value:'5'},
    {label:'产假',value:'6'},
    {label:'婚假',value:'7'},
    {label:'丧假',value:'8'},
  ];
  
  // 请假审批状态
  const statusApplyOpt = [
    {label:'待审批',value:'1'},
    {label:'部门审批通过',value:'2'},
    {label:'部门审批拒绝',value:'3'},
    {label:'行政审批通过',value:'4'},
    {label:'行政审批拒绝',value:'5'},
    {label:'已取消',value:'6'},
  ];
  // '问题等级 1-普通 2-精华
  const levelsOpt = [
    {label:'普通',value:'1'},
    {label:'精华',value:'2'},
  ];
  
  
  // '回复等级 1-普通 2-精华
  const levelsHFOpt = [
    {label:'普通',value:'1'},
    {label:'精华',value:'2'},
  ];
  // '问题是否置顶 0-否 1-是
  const isTopOpt = [
    {label:'否',value:'0'},
    {label:'是',value:'1'},
  ];
  
  // '问题审批状态
  const statusAnswerOpt = [
    {label:'待审批',value:'0'},
    {label:'审批通过',value:'1'},
  ];
  
  //状态:1-待市场审批，10-市场审批拒绝 2-待总监审批 20-总监审批拒绝 3-待财务退款 4-已退款 5-已取消
  const statusTfspOpt = [
    {label:'待市场审批',value:'1'},
    {label:'待总监审批',value:'2'},
    {label:'待财务退款',value:'3'},
    {label:'已退款',value:'4'},
    {label:'已取消',value:'5'},
    {label:'市场审批拒绝',value:'10'},
    {label:'总监审批拒绝',value:'20'},
  ];
  //    尾款支付方式 1-线上，2-线下
  const payTypeOpt = [
    {label:'线上',value:'1'},
    {label:'线下',value:'2'},
  ];
  
  //    付款阶段type
  const typeFkOpt = [
    {label:'支付定金',value:'1'},
    {label:'期款',value:'2'},
    {label:'尾款',value:'3'},
    {label:'指导顺风车',value:'4'},
    {label:'机关增加款',value:'5'},
  ];
  // statusSerOpt    int(11) DEFAULT '1' COMMENT '合同状态 0-待填写信息 1-正常服务中，2-服务暂停，
//   3-服务中止非退费 4-服务终止已退费 5-已结案，6-待审批 7-审批拒绝',
  const statusSerOpt = [
    {label:'待填写信息',value:'0'},
    {label:'正常服务中',value:'1'},
    {label:'服务暂停',value:'2'},
    // {label:'服务中止非退费',value:'3'},
    {label:'已退费解除',value:'4'},
    {label:'已解冻结案',value:'5'},
    {label:'待审批',value:'6'},
    {label:'审批拒绝',value:'7'},
    {label:'合同撤销',value:'8'},
    {label:'未解冻解除',value:'9'},
  ];
  //解卡合同管理-合同状态==》结案归档
  const statusSerHtOpt = [
    {label:'已解冻结案',value:'5'},
    {label:'未解冻解除',value:'9'},
    {label:'已退费解除',value:'4'},
  ];
  //合同审批   审批状态
  const statusSpOpt = [
    {label:'审批通过',value:'1'},
    {label:'审批拒绝',value:'7'},
  ];
  //部门类型   type  1：前端  2：后端
  const typeDeparOpt = [
    {label:'前端',value:'1'},
    {label:'后端',value:'2'},
    {label:'线索',value:'3'},
    {label:'运营',value:'4'},
    {label:'文书',value:'5'},
  ];
  // statusAskOpt  咨询记录状态 1-未处理 2-已回复 3-已删除
  const statusAskOpt = [
    {label:'未处理',value:'1'},
    {label:'已回复',value:'2'},
    {label:'已删除',value:'3'},
  ];
   //  律师申请状态 0-未申请 1-申请中，待指派律师 2-已指派律师 3-待重新指派
  const lawyerStatusOpt = [
    // {label:'未申请',value:'0'},
    {label:'待指派律师',value:'1'},
    {label:'已指派律师',value:'2'},
    {label:'待重新指派',value:'3'},
    {label:'暂不指派律师',value:'4'},
    {label:'已取消',value:'5'},
    {label:'处理完成',value:'6'},
  ];
    // 合同类型 1-委托 2-纯协商
    const orderTypeOpt = [
        {label:'委托',value:'1'},
        {label:'纯指导',value:'2'},
        {label:'纯指导不分账',value:'5'},
        {label:'1转非分账',value:'3'},
        {label:'解除合同',value:'4'},
    ];
    // kpi  休假-考勤类型
    const timeTypeOpt = [
        {label:'周六上班',value:'1'},
        {label:'周日上班',value:'2'},
        {label:'双休',value:'3'},
    ];
    //小组管理  考勤类型 1-全天 2-早班 3-晚班
    const workTypeOpt = [
    {label:'全天',value:'1'},
    {label:'早班',value:'2'},
    {label:'晚班',value:'3'},
    ];
    // 合同管理  是否有风代   // 企微管理 是否只查敏感词
    const isRiskOpt = [
        {label:'是',value:'1'},
        {label:'否',value:'0'},
    ];
    // 线索阶段 1-待定 2-有效 3-无效 4-已成交"
    const validStatusOpt = [
        {label:'待定',value:'1'},
        {label:'有效',value:'2'},
        {label:'无效',value:'3'},
        {label:'已成交',value:'4'},
    ];
    // 平台类型 1-银行 2-网贷
    const typeOpt = [
        {label:'银行',value:'1'},
        {label:'网贷',value:'2'},
    ];
    // 服务费支付状态 1-正常支付中，2-逾期，3-已结清
    const payStatusOpt = [
        {label:'正常支付中',value:'1'},
        {label:'逾期',value:'2'},
        {label:'已结清',value:'3'},
    ];
    // 岗位类型
    const positionTypeOpt = [
        {label:'市场',value:'1'},
        {label:'运营',value:'2'},
        {label:'债务',value:'3'},
        {label:'人事行政',value:'4'},
        {label:'技术',value:'5'},
        {label:'其他',value:'0'},
    ];
    // payStatusOrderOpt 订单查询 支付状态 0-待支付 1-支付成功 2-支付失败 3-已取消
    const payStatusOrderOpt = [
        {label:'待支付',value:'0'},
        {label:'支付成功',value:'1'},
        {label:'支付失败',value:'2'},
        {label:'已取消',value:'3'},
    ];
    // 机/卡来源 1-律所 2-自备
    const phoneTypeOpt = [
        {label:'律所',value:'1'},
        {label:'自备',value:'2'},
    ];
    // 机/卡状态 1-正常 2-锁卡 3-停机 4-解锁处理中
    const phoneStatusOpt = [
        {label:'正常',value:'1'},
        {label:'锁卡',value:'2'},
        {label:'停机',value:'3'},
        {label:'解锁处理中',value:'4'},
    ];
    // status 协商结果 2-协商中 3-已协商缓催 4-已结案
  const statusJGOpt = [
    {label:'协商中',value:'2'},
    {label:'已协商缓催',value:'3'},
    {label:'已结案',value:'4'},
  ];
  
    //  公司类型 type (value = "公司类型 1-解债 2-解卡 3-其他")
    const typeGsOpt = [
        {label:'解债',value:'1'},
        {label:'解卡',value:'2'},
        {label:'其他',value:'3'},
      ];
  
    // 企微管理 type (value = "类型 1-内部员工 2-外部客户',)
    const typeQWOpt = [
        {label:'内部员工',value:'1'},
        {label:'外部客户',value:'2'},
    ];
  // status 协商状态 1-未协商 2-协商中 3-已协商缓催 4-已结案
const statusZTOpt = [
  {label:'未协商',value:'1'},
  {label:'协商中',value:'2'},
  {label:'已协商缓催',value:'3'},
  {label:'已结案',value:'4'},
];
  // status 线索管理  1-待分配 2-待领取 3-待处理 4-待支付 5-已结束
  const statusClueOpt = [
    {label:'待分配',value:'1'},
    {label:'待领取',value:'2'},
    {label:'待处理',value:'3'},
    {label:'待创建客户',value:'4'},
    {label:'待支付',value:'5'},
    {label:'已结束',value:'6'},
  ];
// status 待转账 2-已转账 3-转账失败 4-已取消
const statusTrOpt = [
    {label:'待转账',value:'1'},
    {label:'已转账',value:'2'},
    {label:'转账失败',value:'3'},
    {label:'已取消',value:'4'},
  ];
//银行账户类型，1:对公账户;2:对私账户
const bankAccountTypeOpt = [
{label:'对公账户',value:'1'},
{label:'对私账户',value:'2'},
];
//线索管理  是否自动分配 0-否，1-是
const autoClueOpt = [
{label:'否',value:'0'},
{label:'是',value:'1'},
];
// 是否已出合同,isOrder:1 是；0否"
const isOrderOpt = [
{label:'否',value:'0'},
{label:'是',value:'1'},
];
//是否完成电话客服 0-否，1-是
const phoneEndOpt = [
{label:'否',value:'0'},
{label:'是',value:'1'},
];
//是否查询新线索 0-否，1-是
const isNewClueOpt = [
{label:'否',value:'0'},
{label:'是',value:'1'},
];
//解卡合同 增加客户来源source 1-线索 2-其他。缺省为线索
const sourceOpt = [
// {label:'线索',value:'1'},
// {label:'其他',value:'2'},
    {label:'线索',value:'1'},
    {label:'转介绍',value:'2'},
    {label:'自找资源',value:'3'},
];

//解卡合同  客户管理=》 增加客户来源
const sourceMemberOpt = [
    {label:'线索',value:'1'},
    {label:'转介绍',value:'2'},
    {label:'自找资源',value:'3'},
    ];
//支付通道 weixin-微信,alipay-支付宝,xinyebang-欣业邦支付
const channelOpt = [
{label:'微信',value:'xinyebangweixin'},
{label:'支付宝',value:'xinyebangalipay'},
{label:'银行卡转账',value:'xinyebangtrans'},
{label:'线下付款',value:'offline'},
// {label:'欣业邦支付',value:'xinyebang'},
];

//退费管理=》退费渠道 “本人支付宝、本人银行卡、其他、微信原路退回
const channelTfOpt = [
    {label:'本人支付宝',value:'本人支付宝'},
    {label:'本人银行卡',value:'本人银行卡'},
    {label:'微信原路退回',value:'微信原路退回'},
    {label:'其他',value:'其他'},
    ];


//分账状态 0-不分账，1-待分账，2-已分账，3-分账失败 4-已申请分账待响应
const divideStatusOpt = [
    {label:'不分账',value:'0'},
    {label:'待分账',value:'1'},
    {label:'已分账',value:'2'},
    {label:'分账失败',value:'3'},
    {label:'已申请分账待响应',value:'4'},
    ];
//是否可点击跳转 1-不能点击 2-点击跳转内部模块 3-点击弹窗显示外部网址
const clickTypeOpt = [
    {label:'不能点击',value:'1'},
    {label:'点击跳转内部模块',value:'2'},
    {label:'点击弹窗显示外部网址',value:'3'},
    ];

// //证件类型 CRED_PSN_CH_IDCARD-身份证 CRED_PSN_CH_HONGKONG-香港通行证 CRED_PSN_CH_MACAO-澳门通行证  CRED_PSN_CH_TWCARD
//  - 台湾来往大陆通行证（台胞证）CRED_PSN_PASSPORT - 护照
const cardtypeOpt = [
    {label:'身份证',value:'CRED_PSN_CH_IDCARD'},
    {label:'香港通行证',value:'CRED_PSN_CH_HONGKONG'},
    {label:'澳门通行证',value:'CRED_PSN_CH_MACAO'},
    {label:'台湾来往大陆通行证(台胞证)',value:'CRED_PSN_CH_TWCARD'},
    {label:'护照',value:'CRED_PSN_PASSPORT'},
    ];
// 易分达 轮播图类型 轮播图类型 1-首页顶部轮播图，2-产品介绍顶部轮播图,3-机构合作顶部轮播图，4-最新动态顶部轮播图，5-行业经验顶部轮播图，6-关于我们顶部轮播图，" +
// "7-最新动态-通知公告,8-最新动态-新闻咨询,9-最新动态-招聘发布,10-行业经验-K12培训案例分享,11-行业经验-技能培训案例分享,12-行业经验-招考培训案例分享," +
// "13-关于我们-公司简介,14-关于我们-联系我们,15-公众号二维码,16-微博二维码,17-抖音二维码,18-产品介绍-产品特色,19-首页-产品特色,20-机构合作-合作伙伴，" +
// "21-行业经验-兴趣培训案例分享
const bannerTypeOpt = [
    {label:'首页-顶部轮播图(1920x931)',value:'1'},
    {label:'首页-关于我们-图片(1382x650)',value:'2'},
    {label:'首页-相关产品-图片(554x343)',value:'3'},
    {label:'首页-产品特色-图片(212x237)',value:'4'},
    {label:'首页-产品特色-中心图片(528x396)',value:'5'},
    {label:'首页-最新动态-图片(384x231)',value:'6'},
    {label:'产品介绍模块-顶部轮播图(1920x536)',value:'7'},
    {label:'产品介绍模块-产品特色-图片(190x213)',value:'8'},
    {label:'机构合作模块-顶部轮播图(1920x676)',value:'9'},
    {label:'机构合作模块-合作伙伴-图片(181x209)',value:'10'},
    {label:'最新动态模块-顶部轮播图(1920x536)',value:'11'},
    {label:'最新动态模块-通知公告-图片(480x288)',value:'12'},
    {label:'最新动态模块-新闻资讯-图片(480x288)',value:'13'},
    {label:'最新动态模块-招聘发布-图片(480x288)',value:'14'},
    {label:'行业经验模块-顶部轮播图(1920x536)',value:'15'},
    {label:'行业经验模块-K12培训案例分享-轮播图(1344x565)',value:'16'},
    {label:'行业经验模块-兴趣培训案例分享-轮播图(1344x565)',value:'17'},
    {label:'行业经验模块-技能培训案例分享-轮播图(1344x565)',value:'18'},
    {label:'行业经验模块-招考培训案例分享-轮播图(1344x565)',value:'19'},
    {label:'关于我们模块-顶部轮播图(1920x536)',value:'20'},
    {label:'关于我们模块-公司简介-图片(1382x650)',value:'21'},
    {label:'关于我们模块-联系我们-图片(1036x667)',value:'22'},
    {label:'底部-公众号二维码(88x88)',value:'23'},
    {label:'底部-微博二维码(88x88)',value:'24'},
    {label:'底部-抖音二维码(88x88)',value:'25'},
    {label:'底部-(logo+名字)图片(172x76)',value:'26'},
    {label:'顶部-(logo+名字)图片(167x68)',value:'27'},
    ];
    
// 宽航官网 轮播图类型 轮播图类型
//  1-首页-顶部轮播图，2-首页-顶部轮播图-图片,3-首页-关于宽航-图片，4-首页-发展历程-文字标题，
// 5-首页-律师团队-背景图片，6-首页-律师团队-律师图片，
// 7-首页-业务领域-背景图片,8-首页-业务领域-领域文字标题,9-首页-合作案例-背景图片,10-首页-合作案例-案例图片,
// 11-首页-业务流程-背景图片,12-首页-业务流程-流程文字标题,
// "13-首页-联系我们-图标文字标题,14-首页-案件咨询-背景图片,15-底部-公众号二维码+文字标题,16-底部-(logo+名字)图片,
// 17-顶部-(logo+名字)图片
const bannerTypeKhOpt = [
    {label:'首页-顶部轮播图(1920*693)-文案',value:'100'},
    {label:'首页-关于多仑-文案描述(图片:588*358)',value:'102'},
    {label:'首页-核心技术-标题',value:'106'},
    {label:'首页-核心技术-文案描述(图片:108*108)',value:'103'},
    {label:'首页-核心技术-文案描述背景(图片:108*108)',value:'113'},
    {label:'首页-核心优势-图片(500*500)',value:'104'},
    {label:'首页-核心优势-文案描述',value:'105'},
    {label:'首页-资质认证-标题',value:'107'},
    {label:'首页-资质认证-文案描述(图片:278*214)',value:'108'},
    {label:'首页-应用领域-标题',value:'109'},
    {label:'首页-应用领域-文案描述(547*213)',value:'110'},
    {label:'首页-售后服务申请-背景图(1440*1040)',value:'111'},
    {label:'首页-立即注册-文案描述',value:'112'},

    
    {label:'产品介绍-顶部轮播图(1920*533)',value:'300'},
    {label:'产品介绍-多仑产品(517*480)-文案描述',value:'301'},

    
    {label:'技术服务-顶部轮播图(1920*533)-文案',value:'400'},
    {label:'技术服务-标题',value:'401'},
    {label:'技术服务-模块1(left)-文案图片(784*477)',value:'402'},
    {label:'技术服务-模块1(right)-文案图片(29*36)',value:'403'},
    {label:'技术服务-模块2()-文案图片(220*220)',value:'404'},
    {label:'技术服务-模块3(技术优势)-文案图片(992*392)',value:'405'},
    {label:'技术服务-模块3(技术优势)-文案描述',value:'406'},
    {label:'技术服务-模块4(技术对比)-标题',value:'407'},
    {label:'技术服务-模块4(技术对比)-文案描述1',value:'408'},
    {label:'技术服务-模块4(技术对比)-文案描述2',value:'409'},
    {label:'技术服务-模块4(技术对比)-文案描述3',value:'410'},
    {label:'技术服务-模块4(技术对比)-文案描述4',value:'411'},
    {label:'技术服务-模块4(技术对比)-文案描述5',value:'413'},
    {label:'技术服务-模块4(技术对比)-文案描述6',value:'414'},
    {label:'技术服务-立即注册-文案描述',value:'412'},

    
    {label:'应用领域-顶部轮播图(1920*640)-文案',value:'500'},
    {label:'应用领域-模块1(行业应用)-标题文案',value:'501'},
    {label:'应用领域-模块1(行业应用)-文案(160*160)',value:'502'},
    
    {label:'应用领域-模块1(行业应用更新版)-文案(160*160)',value:'510'},

    {label:'应用领域-模块2(未来战略)-标题文案',value:'503'},
    {label:'应用领域-模块2(未来战略)-中心图片(554*585)',value:'504'},
    {label:'应用领域-模块2(未来战略)-文案',value:'505'},
    {label:'应用领域-模块3(发展规划)-标题文案',value:'506'},
    {label:'应用领域-模块3(发展规划)-中心图片(403*378)',value:'507'},
    {label:'应用领域-模块3(发展规划)-文案',value:'508'},
    {label:'应用领域-模块4()-文案',value:'509'},


    
    {label:'关于我们-顶部轮播图(1920*640)-文案',value:'600'},
    {label:'关于我们-模块1(核心价值观)-标题',value:'601'},
    {label:'关于我们-模块1(核心价值观)-图片(1506*304)',value:'602'},
    {label:'关于我们-模块2(精英团队)-中心图片(564*564)',value:'603'},
    {label:'关于我们-模块2(精英团队)-文案',value:'604'},
    {label:'关于我们-模块3(地图)-图片(1921*1079)',value:'605'},

    
    
    {label:'联系我们-顶部轮播图(1920*640)-文案',value:'700'},
    {label:'联系我们-mod1(以水之名)-文案',value:'701'},
    {label:'联系我们-mod2(safe For life)-文案',value:'702'},
    {label:'联系我们-mod3(联系方式)-标题',value:'703'},
    {label:'联系我们-mod3(联系方式)-文案',value:'704'},




    {label:'公用顶部模块-logo+文字(119*42)',value:'200'},
    {label:'公用顶部模块-导航文案',value:'201'},
    {label:'公用顶部模块-登录',value:'202'},
    {label:'公用底部模块-logo+文字(119*42)',value:'203'},
    {label:'公用底部模块-联系我们-标题',value:'204'},
    {label:'公用底部模块-联系我们-信息描述',value:'205'},
    // {label:'公用底部模块-联系我们-联系电话',value:'206'},
    // {label:'公用底部模块-联系我们-公司地址',value:'207'},
    {label:'公用底部模块-快速连接-标题',value:'208'},
    {label:'公用底部模块-快速连接-导航描述',value:'209'},
    // {label:'公用底部模块-快速连接-产品中心',value:'210'},
    // {label:'公用底部模块-快速连接-新闻资讯',value:'211'},
    // {label:'公用底部模块-快速连接-加入我们',value:'212'},
    {label:'公用底部模块-关注我们-标题',value:'213'},
    {label:'公用底部模块-关注我们-logo图片(20*20)',value:'214'},
    {label:'公用底部模块-备案',value:'215'},

    
    {label:'公用图片-√图片(16*16)',value:'1'},
    {label:'公用图片-left_img(380*157)',value:'2'},
    {label:'公用图片right_img(380*157)',value:'3'},
    {label:'公用图片-方块图片(27*24)',value:'4'},
    {label:'公用图片-图片5(172*194)',value:'5'},
    {label:'微信公众号-图片5(250*250)',value:'6'},
    {label:'企微客服-图片5(250*250)',value:'7'},
   
    ];
 const returnTypeArr = ["status","type","gender","orderType","payStatus","phoneType","phoneStatus","channel","divideStatus",
 "bannerType","clickType","remainType","statusClue","payType","validStatus","autoClue","lawyerStatus","workType","phoneEnd",
 "isOrder","bannerKhType","levels","isTop","source","isValid","pjRoleType","statusKpi","operType","operTypeAll","isRisk","timeType","channelTf",
"typeFk","positionType",,"workStatusSearch","statusUser"];
export default{
    //返回options
    getOption(str){
        console.log("=================",str)
        return eval(str+'Opt')
    },
    formatTimer(timer,type){
        // if(!time) return "暂无数据"
        if(!timer) return "--"
        let time = new Date(timer);
        let y = time.getFullYear();
        let m = time.getMonth()+1;
        let d = time.getDate();
        if(type == 'day'){
            return y+'-'+add0(m)+'-'+add0(d);
        }else if(type == 'year'){
            return y;
        }else if(type == 'month'){
            return m;
        }else if(type == 'date'){
            return d;
        }else if(type == 'y-m-d'){
            return y+'-'+add0(m)+'-'+add0(d);
        }else{
            let h = time.getHours();
            let mm = time.getMinutes();
            let s = time.getSeconds();
            return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
        }
    },
    //文件上传  action

// 附件上传，附件格式fileType：1-图片，2-录音 3-短信
// type:附件类型1-订单佐证2-订单审批，3-订单放款     0  客户头像
    uploadAction(fileParams){
        let Obj = {};
        let actionUrl = ""
        if(process.env.NODE_ENV == "production" ){
            actionUrl = "https://crmgate.efenda.cn"
        }else{
            // actionUrl = "http://192.168.10.123:8091/api";
            actionUrl = "https://crmgate.efenda.cn"
        }
        if(!fileParams){
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/minio/upload?type=1&fileType=1`
            return Obj;
        }else if(fileParams == 'exportUser'){
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/order/uploadDebit`
            return Obj;
        }else if(fileParams == 'importDivider'){
            //获取Authorization   批量导入分配律助
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/order/importDivider`
            return Obj;
        }else if(fileParams == 'importPhone'){
            //获取Authorization   批量导入分配客服
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/order/importPhone`
            return Obj;
        }else if(fileParams == 'exportClueImport'){
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/clue/importFeiYu`
            return Obj;
        }else if(fileParams == 'importKpiHours'){
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/kpi/importKpiHours`
            return Obj;
        }else if(fileParams == 'importKpiTmpHours'){
            //导入打卡机  考勤
            //获取Authorization
            const token = Cookies.get('loginToken')
            Obj.headers = {Authorization:token};
            Obj.action =  `${actionUrl}/kpi/importKpiTmpHours`
            return Obj;
        }else{
            let fileType = fileParams.fileType || '1';//默认为图片
            // store.state.pageStore.fileType;
            if(store.state.pageStore.fileType){
                fileType = store.state.pageStore.fileType;
            }
            
            let type = fileParams.type || '0';//默认客户头像
            let orderId = fileParams.orderId;
        
            if(orderId){
                Obj.action = `${actionUrl}/minio/upload?type=${type}&fileType=${fileType}&orderId=${orderId}`
            }else{
                //针对客户头像
                Obj.action = `${actionUrl}/minio/upload?type=${type}&fileType=${fileType}`
            }
            return Obj;
        }
        
    },
    //根据filed返回相应的状态值 label.type = 1,执行options逻辑   type == 2  执行转换时间戳
    // dataObj:数据源    label:当前label数据
    // label.type  number类型
    // rValByFiled(dataObj,label){
        
    //根据filed返回相应的状态值 label.type = 1,执行options逻辑   type == 2  执行转换时间戳
    // dataObj:数据源    label:当前label数据
    // label.type  number类型   isSub   是否截取     subNum 截取数量
    rValByFiled(dataObj,label,isSub,subNum){
        // if(Object.keys(dataObj).length == 0) return "暂无数据";
        if(Object.keys(dataObj).length == 0) return "--";
        let value = dataObj[label.filed]
        if(Object.prototype.toString.call(value) == '[object Number]'){
            value = value.toString();
        }
        let valLabel = "";
        switch(label.type){
            case 1:
                //执行options逻辑
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'Opt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 2:
                //执行转换时间格式  年月日  时分秒
                return formatTimer(value);
            break;
            case 3:
                //执行options逻辑   status   statusAccountOpt 账号启用状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'AccountOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 4:
                //执行options逻辑   status   statusSerOpt 账号启用状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'SerOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 5:
                //执行options逻辑   status   statusJGOpt 协商结果
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'JGOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 6:
                //执行options逻辑   status   statusZTOpt 协商状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'ZTOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 7:
                //执行options逻辑   payStatus   payStatusOrderOpt 协商状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'OrderOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 8:
                //执行options逻辑   status 待转账 2-已转账 3-转账失败 4-已取消
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'TrOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 9:
                //执行options逻辑   statusAskOpt 咨询状态 1-未处理 2-已回复 3-已删除
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'AskOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 11:
                //执行options逻辑   statusSpOpt 审批状态 1-正常 7-拒绝
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'SpOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 12:
                //执行options逻辑   typeGsOpt 公司类型
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'GsOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 13:
                //执行options逻辑   typeDeparOpt 部门类型
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'DeparOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 14:
                //执行options逻辑   status   线索管理   状态 statusClueOpt
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'ClueOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 15:
                //执行options逻辑   type   answerTypeOpt 问题类型
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'AnswerOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 16:
                //执行options逻辑   status   statusAnswerOpt 问题状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'AnswerOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 17:
                //执行options逻辑   levels   levelsHFOpt 回复等级
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'HFOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            
            case 18:
                //执行options逻辑   type   typeDynamicOpt 信息类型
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'DynamicOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            
            case 19:
                //执行options逻辑   type   statusTfspOpt 退费管理=》审批状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'TfspOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            
            case 20:
                //执行options逻辑   status   statusKpiOpt 绩效考核=状态》statusUser
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'KpiOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 22:
                //具体到天
                return formatTimer(value,'day')
            break;
            case 23:
                //执行options逻辑  退费管理=》退费渠道 channelTf   channelTfOpt 回复等级
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'TfOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 24:
                //执行options逻辑   typeFk   typeFkOpt  付款阶段
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'FkOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 25:
                //执行options逻辑   status   statusSerHtOpt 账号启用状态
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'SerHtOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 26:
                //执行options逻辑  typeQWOpt 企微管理 type (value = "类型 1-内部员工 2-外部客户',)
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'QWOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            
            
            case 27:
                //执行options逻辑   status   状statusUserOpt 绩效考核=状态》status
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'UserOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 28:
                //执行options逻辑   type   typeApplyOpt 请假类型  type
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'ApplyOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 29:
                //执行options逻辑   status   statusApplyOpt 请假类型  type
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'ApplyOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 888:
                //执行options逻辑   bannerKhType   宽航官网   状态 bannerTypeKhOpt
                for(let item of returnTypeArr){
                    if(item == label.filed){
                        let arrStr = eval(label.filed+'KhOpt') 
                        for(let itm of arrStr){
                            if(value == itm.value){
                                valLabel = itm.label;
                                break;
                            }
                        }
                        break;
                    }
                }
                return valLabel;
            break;
            case 10:
                 //用于拼接字段   type:10,filedArr:['xrate','yrate'],format:'/'
                 let filedArr = label.filedArr || [];
                for(let item of filedArr){
                    let filedVal = dataObj[item] || "-";
                    valLabel += `${filedVal}${label.format}`
                }
                valLabel = valLabel.replace(/.$/, "");//替换最后一个字符串
                return valLabel;
            break;
            case 999:
                //------根据不同类型值，拼接不同的单位
                if(label.unitType == 'unitType'){
                    let unitArr = label.unit;
                    if(Object.prototype.toString.call(unitArr) == '[object Array]' && unitArr.length > 0){
                        for(let unitItem of  unitArr){
                            if(!unitItem.filed){
                                break;
                            }
                            let type = dataObj[unitItem.filed];
                            if(type == unitItem.value){
                                valLabel = value + unitItem.unit
                                break;
                            }
                        }
                    }else{
                        valLabel = value
                    }
                }else{
                    valLabel = value + label.unit
                }
                return valLabel;
            break;
            default:
                // if(!value){
                //     // return "暂无数据";
                //     return "--";
                // }
                // return dataObj[label.filed]
                if(!value){
                    // return "暂无数据";
                    return "--";
                }else{
                    let subNumer = subNum || 7;
                    if(isSub && value.length > subNumer){
                        value = value.substr(0,subNumer)+'...'
                    }
                }
                return value;
        }
        
    },
    //根据字段状态值获取options return=>value值
    getOptByFiledVal(fieldVal,fieldOptVal){
        let valLabel = "";
        if(!fieldOptVal || !fieldVal){
            return valLabel
        }
        let arrStr = eval(fieldOptVal+'Opt') 
        for(let itm of arrStr){
            if(fieldVal == itm.value){
                valLabel = itm.label;
                break;
            }
        }
        return valLabel;
    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   dataObj数据源
    echoFiled(label,filed,labelList,dataObj){
        if(labelList.length == 0 || !label ||  !filed) return ""
        for(let item of labelList){
            if(label == item.label){
              item[filed] = dataObj;
              break;
            }
          }
    },
    // 根据字段名称值，来赋值。。。
    echoByFiled(filedVal,filed,labelList,dataObj){
        if(labelList.length == 0 || !filedVal ||  !filed) return ""
        for(let item of labelList){
            if(filedVal == item.filed){
              item[filed] = dataObj;
              break;
            }
          }
    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   value值
    echoFiledVal(label,filed,labelList,val){
        if(labelList.length == 0 || !label || !filed) return ""
        for(let item of labelList){
            if(label == item.label){
              item[filed] = val;
              break;
            }
          }
    },
    // 给labelList 中的字段赋值数据源  filed,
    //label  字段名字   labelList 字段列表   dataObj数据源
    echoValue(label,labelList,dataObj){
        if(labelList.length == 0 || !label ) return ""
        for(let item of labelList){
            if(label == item.label){
              item.value = dataObj;
              break;
            }
          }
    },
    // 根据字段得到labelList 中的值
    getFiledVal(label,labelList){
        if(labelList.length == 0 || !label ) return "";
        let val = "";
        for(let item of labelList){
            if(label == item.label){
                val = item.value;
              break;
            }
          }
          return val;
    },
    /**
     * //获取对象数组value值
     * @param {*} objArr 
     * @param {*} data 
     * @returns obj
     */
    getDataObj:(objArr)=>{
        let valObj = {}
        if(objArr.length == 0 || !objArr) return valObj;
        for(let item of objArr){
            if(!item){
                return;
            }
            //时间  需要拆分  多个字段 startTimer  endtimer
            if(item.typeValue == 'daterange' && item.filedArr){
                for(let [index,im] of item.filedArr.entries()){
                    valObj[im] = item.value ? item.value[index] : "";
                }
            }else if(item.typeValue == 'datetimerange' && item.filedArr){
                for(let [index,im] of item.filedArr.entries()){
                    valObj[im] = item.value ? item.value[index] : "";
                }
            }else if(item.typeValue == 'monthrange' && item.filedArr){
                for(let [index,im] of item.filedArr.entries()){
                    valObj[im] = item.value ? item.value[index] : "";
                }
            }else if(item.typeValue == 'input_section' && item.inputSection.length != 0){
                let startVal = "",endVal = "";
                let startLabel="",endLabel = "";
                let isBreak = false;
                for(let [index,im] of item.inputSection.entries()){
                    valObj[im.filed] = im.value || "";
                    console.log("----------------------------",im,index)
                    startVal = item.inputSection[0].value;
                    endVal = item.inputSection[1].value;
                    startLabel = item.inputSection[0].label;
                    endLabel = item.inputSection[1].label;
                }
                if(startVal && endVal){
                    if(Number(startVal) > Number(endVal) ){
                        isBreak = true;
                         Message({
                            message:`${startLabel}不能小于${endLabel}`,
                            type:"error",
                            duration:1500,
                        })
                    }
                }
                if(isBreak){
                    console.log("终止数据")
                    break;
                }
            }else{
                valObj[item.filed] = item.value;
            }
        }
        return valObj;
    },
    /**
     * 重置数据对象
     */
    resetObj:(objArr)=>{
        if(objArr.length == 0 || !objArr) return "";
        for(let item of objArr){
            if(item.typeValue == 'input_section' && item.inputSection.length != 0){
                for(let im of item.inputSection){
                    im.value = item.resetValue || "";
                }
            }else if(item.typeValue == 'select' && item.multiple){
                item.value = item.resetValue || [];
            }else{
             item.value = item.resetValue || "";
            }
        }
    },
    // number类型转String类型
    numTostring(val){
        if(Object.prototype.toString.call(val) == '[object Number]'){
            val = val.toString();
        }
        if(val == null){
            return ""
        }
        return val;
    },
    //更改lableList  中的typeValue类型值  typeValue
    /**labelStr:label名
     * labelList 数据源
     * valStr 更改的value值
     */
    updateLableFiled(labelStr,labelList,valStr){
        if(!labelStr || labelList.length == 0 || !valStr) return "";
        for(let item of labelList){
            if(labelStr == item.label){
                item.typeValue = valStr
                break;
            }
        }
    },
    //得到rules,并得到值
    getRule(arr){
        let obj = {};
        if(arr.length == 0 || !arr) return obj
        for(let item of arr){
            obj[item.filed] = item.value;
        }
        return obj;
    },
    //得到rules,并得到当前监听列表的值
    getWatchRule(arr){
        let obj = {};
        if(arr.length == 0 || !arr) return obj
        for(let item of arr){
            if(item.value){
                obj[item.filed] = item.value;
            }
        }
        return obj;
    },
    // 数组对象赋值？
    /**
     * 
     * @param {*} labelArr  数组数据结构对象
     * @param {*} dataObj   dataObj 数据源对象
     */
    echoArrData(labelArr,dataObj){
        if(labelArr.length == 0 || !labelArr) return [];
        if(!dataObj) return [];
        for(let item of labelArr){
            item.value = dataObj[item.filed];
            if(item.fileList && Object.prototype.toString.call(item.fileList) == '[object Array]'){
                item.fileList = splitFile(dataObj[item.filed])
            }
        }
        return labelArr;
    },
    //回显对象数据
    objEcho:(obj,data)=>{
        if(Object.prototype.toString.call(obj) === '[object Object]' && 
            Object.keys(obj) != 0){
                for(let key in obj){
                    let val = data[key];
                    if(Object.prototype.toString.call(val) == '[object Number]'){
                        val = val.toString();
                    }
                    if(val){
                        obj[key] = val
                    }
                }
        }
        return obj;
    },
    //赋值select数据
    assSelectData(){},
    //暂无数据
    noData(value){
        if(Object.prototype.toString.call(value) == '[object Number]'){
            value = value.toString();
        }
        // if(!value) return '暂无数据'
        if(!value) return '--'
        return value;
    },
    //时间format转换
   format:(time)=>{
        if(!time) return "--"
        var time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
    },
    formatTime:(time)=>{
        var time = new Date(time);
        var y = time.getFullYear();
        var m = time.getMonth()+1;
        var d = time.getDate();
        return y+'-'+add0(m)+'-'+add0(d);
    },
    //二进制文件对象转换img base64
    readImg(file){
        return new Promise((resolve,reject)=>{
            const img = new Image();
            const reader = new FileReader();
            reader.onload = function(e){
                // img.src = e.target.result;
                resolve(e.target.result)
            }
            reader.onerror = function(e){
                reject(e)
            }
            reader.readAsDataURL(file);
            // img.onload = function(){
            //     resolve(img)
            // }
            // img.onerror = function(e){
            //     reject(e)
            // }
        })
    },
    msg(title,type='success',duration=1500){
        Message({
            message:title,
            type:type,
            duration:duration,
        })
    },
    labelByValue(item){
        let labelType = item.labelType || 0;
        let labelValue = "";
        switch(labelType){
            case 1:
                let typeVals = item.typeValues;
                let companyId = sessionStorage.getItem("companyId") || '0';
                for(let tyItem of typeVals){
                    if(companyId == tyItem.value){
                        labelValue = tyItem.label;
                        break;
                    }else{
                        labelValue = tyItem.label
                    }
                }
            break;
            default:
                labelValue = item.label
                console.log("labelType  特定值处理",labelType)
        }
        return labelValue;
    },
    
    //针对table  列 label
    labelByValue_global(item){
        return item.label;
        let labelValue = "";
        if(item.isBolLabel){
            labelValue = item.label
        }else{
            //全局兼容
            if(item.label.indexOf("公司名称") != -1 || item.label.indexOf("客户公司") != -1  || item.label == "部门"){
                labelValue = "所属项目";
            }else{
                let loginId = sessionStorage.getItem("loginId");
                // 13  是重庆宽航公司  iskpi = 1
                    if(loginId == 13 || loginId == 'null'){
                        if(item.label.indexOf("市场专员") != -1 || 
                            item.label.indexOf("业务员") != -1 ||
                            item.label.indexOf("顾问") != -1){
                            labelValue = "律助(前端答疑)";
                        }else if(item.label.indexOf("律助") != -1 || 
                                item.label.indexOf("协商老师") != -1 || 
                                item.label.indexOf("客服/律助") != -1){
                            labelValue = "律助(后端答疑)";
                        }else if(item.label.indexOf("电话客服") != -1 ){
                            labelValue = "律助(建联答疑)";
                        }else{
                            labelValue = item.label
                        }
                    }else{
                        if(item.label.indexOf("业务员") != -1 || item.label.indexOf("市场专员") != -1 ){
                            labelValue = "顾问";
                        }else if(item.label.indexOf("协商老师") != -1 ||
                            item.label.indexOf("律助") != -1 || 
                            item.label.indexOf("客服/律助") != -1){
                            labelValue = "客服";
                        }else{
                            labelValue = item.label
                        }
                    }
            }
        }
        

        //加入前缀
        if(item.isPrefix && item.prefixStr){
            labelValue = `${item.prefixStr}${labelValue}`;
        }

        return labelValue;
    },
    //table表格  label动态适配
    getTableLabel(val1,val2){
        
        let loginId = sessionStorage.getItem("loginId");
        // 13  是重庆宽航公司  iskpi = 1
        if(loginId == 13 || loginId == 'null'){
            return val1;
        }else{
            return val2;
        }
    },
    getKpidate(kpidateStr){
        if(kpidateStr){
            return kpidateStr;
        }
        const date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let kpidate = "";
        if(day > 15){
          kpidate = `${year}${month}01`
        }else{
            if(month == '1'){
                kpidate = `${year - 1}1202`
            }else{
                kpidate = `${year}${month - 1}02`
            }
        }
        return kpidate;
    },

  // 防抖_login_test   //参数l传递
  debounce_login(fn, wait,val) {
    if(fn.id){
        clearTimeout(fn.id)
    }
    return (function (...args) {
        let that = this;
        fn.id = setTimeout(() => {
            fn.apply(that, args)
        }, wait);
    })(val)
},
 // 防抖
debounce(fn, wait) {
    if(fn.id){
        clearTimeout(fn.id)
    }
    return (function (...args) {
        let that = this;
        fn.id = setTimeout(() => {
            fn.apply(that, args)
        }, wait);
    })()
},
// 节流
 throttle(fn, wait) {
    let timer;
    return function (...args) {
        if (!timer) {
            fn.apply(this, args)
            timer = setTimeout(() => {
                timer = null;
            }, wait);
        }
    }
}
}


// WEBPACK FOOTER //
// ./src/utils/utils.js